import { Link } from "react-router-dom";

// items: [{label, to}] - the last one becomes the current page (no link)
export default function Breadcrumbs({ items = [] }) {
  return (
    <nav
      aria-label="Breadcrumb"
      data-testid="breadcrumbs"
      className="text-xs font-sans tracking-[0.14em] uppercase text-[#8E7331]"
    >
      <ol className="flex flex-wrap items-center gap-2">
        {items.map((it, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={`${it.label}-${i}`} className="flex items-center gap-2">
              {isLast ? (
                <span className="text-[#0A1128]" aria-current="page">{it.label}</span>
              ) : (
                <Link
                  to={it.to}
                  data-testid={`breadcrumb-link-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-[#475569] hover:text-[#0A1128]"
                >
                  {it.label}
                </Link>
              )}
              {!isLast && <span className="text-[#B89947]">/</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
